import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["colorInput", "presetSelect"]

  syncFromPreset() {
    const value = this.presetSelectTarget.value
    if (value) this.colorInputTarget.value = value
  }

  syncFromColor() {
    const value = this.colorInputTarget.value
    const match = [...this.presetSelectTarget.options].find(o => o.value.toLowerCase() === value.toLowerCase())
    this.presetSelectTarget.value = match ? match.value : ""
  }
}
